import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Header5 from "../../components/header/Header5";
import Footer3 from "../../components/footer3";
import Gotop from "../../components/gotop";
import { Link, NavLink } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../../assets/siteimages/logo.png";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa"; // Import icons

import Breadcrumbastrologer from "../../components/breadcrumbastrologer";
import { useContext } from "react";
import { AuthContext } from "../../AuthContext";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

DashboardAstroServices.propTypes = {};

function DashboardAstroServices(props) {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({
      live: false,
    });
    window.wow.init();
  }, []);

  const [categories, setCategories] = useState([]);
  const [categoriesnew, setCategoriesnew] = useState([]);
  const [categoriesnew1, setCategoriesnew1] = useState([]);
   const [categoriesnew2, setCategoriesnew2] = useState([]);

  useEffect(() => {
    fetchCategories();
    fetchCategoriesnew();
    fetchCategoriesnew1();
     fetchCategoriesnew2();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/blogcategoriessort"); // Adjust the URL if needed
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching blog categories:", error);
    }
  };

  const fetchCategoriesnew = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/horoscopecategoriessort"); // Adjust the URL if needed
      setCategoriesnew(response.data);
    } catch (error) {
      console.error("Error fetching horoscope categories:", error);
    }
  };

  const fetchCategoriesnew1 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrocategoriessort"); // Adjust the URL if needed
      setCategoriesnew1(response.data);
    } catch (error) {
      console.error("Error fetching astro categories:", error);
    }
  };

   const fetchCategoriesnew2 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/coursecategoriessort"); // Adjust the URL if needed
      setCategoriesnew2(response.data);
    } catch (error) {
      console.error("Error course categories:", error);
    }
  };

const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  
  

  const { logout } = useContext(AuthContext);

const [services, setServices] = useState([]);
const [selected, setSelected] = useState([]);
const [astrologerId, setAstrologerId] = useState(null);

const [experienceMap, setExperienceMap] = useState({});

// Fetch astrologer ID from localStorage and check if services are already set
useEffect(() => {
  const storedUserId = localStorage.getItem("astrologerId");
  if (storedUserId) {
    setAstrologerId(storedUserId);
  }

  // Fetch available services
  axios.get('https://adhigyanam-e92bf1bbbdb1.herokuapp.com/services')
    .then(res => setServices(res.data))
    .catch(err => console.error(err));
}, []);


// helper: returns true if id is present in array
const includesId = (arr, id) => Array.isArray(arr) && arr.includes(id);

const handleCheckboxChange = (id) => {
  // Use functional updater so we always work with latest state
  setSelected(prevSelected => {
    // build the new selected array
    const isAlready = prevSelected.includes(id);
    const newSelected = isAlready ? prevSelected.filter(item => item !== id) : [...prevSelected, id];

    // Now update experienceMap based on newSelected (deterministic)
    setExperienceMap(prevExp => {
      const updated = { ...prevExp };
      if (newSelected.includes(id)) {
        // if newly selected and no value exists, ensure a blank string so the input shows
        if (typeof updated[id] === 'undefined') updated[id] = "";
      } else {
        // if deselected, remove any experience entry for this id
        if (typeof updated[id] !== 'undefined') delete updated[id];
      }
      return updated;
    });

    return newSelected;
  });
};
const [isSubmitting, setIsSubmitting] = useState(false);

const handleSubmit = (e) => {
  e.preventDefault();

  if (selected.length === 0) {
    toast.error("Please select at least one service before submitting.");
    return;
  }

  for (let id of selected) {
    if (!experienceMap[id] || isNaN(experienceMap[id])) {
      toast.error("Please enter valid experience for selected services.");
      return;
    }
  }

  // Build id->name map from services structure (covers categories and subcategories)
  const idNameMap = {};
  services.forEach(cat => {
    // If category itself is selectable (no subcategories), map category.Id
    if (!cat.subcategories || cat.subcategories.length === 0) {
      idNameMap[String(cat.Id)] = cat.Named;
    } else {
      // map subcategories
      cat.subcategories.forEach(sub => {
        idNameMap[String(sub.Id)] = sub.Named;
      });
    }
  });

  // Build serviceData including name (Named) to send to server
  const serviceData = selected.map(id => ({
    id,
    Named: idNameMap[String(id)] || null,
    experience: experienceMap[id]
  }));

  // DEBUG logs
  console.log('DEBUG sending selected IDs:', selected);
  console.log('DEBUG idNameMap sample:', Object.keys(idNameMap).slice(0,8).reduce((acc,k)=> (acc[k]=idNameMap[k], acc), {}));
  console.log('DEBUG final serviceData payload:', serviceData);

  setIsSubmitting(true);

  axios.post('https://adhigyanam-e92bf1bbbdb1.herokuapp.com/selected-services', {
    services: serviceData,
    astrologerId: astrologerId,
  })
  .then(() => {
    return axios.post('https://adhigyanam-e92bf1bbbdb1.herokuapp.com/update-astrologer-service-status', {
      astrologerId: astrologerId
    });
  })
  .then(() => {
    toast.success("Services submitted successfully!");
    setTimeout(() => {
      window.location.href = "/completeprofile";
    }, 5000);
  })
  .catch((err) => {
    console.error('Submit error:', err);
    toast.error("Submission failed. Please try again.");
    setIsSubmitting(false);
  });
};

  return (
    <>
    <Helmet>
            <title>Select Services - Adhigyanam | Sauntesthyam LLP</title>
          </Helmet>
        
        <Breadcrumbastrologer title="Select Services" />
       
        <section className="account-section">
              <div className="tf-container">
                <div className="row">
                  <div>
                <div style={{textAlign:"center", maxWidth:"600px", margin:"auto"}}>
                   <h5 style={{fontSize:"27px"}}>Select Services Offered</h5>
                  <p style={{marginBottom:"20px"}}>Adhigyanam network provide multiple services in different domains. Help us identify your service preferences to allow our customers connect with you based on your service availability.<br/><span style={{fontWeight:"bold"}}>Please Note</span>: This selection will undergo review before finalisation.</p>
                   
                </div>
                 
                      
      
<form onSubmit={handleSubmit} className="services-form" style={{ textAlign: "center" }}>
  <div className="services-grid">
    {services.length === 0 && (
      <div className="no-services">No services currently available. Please contact Support!</div>
    )}

    {services.map(category => (
      <div key={`cat-${category.Id}`} className="category-card">
        <div className="category-header">
          <span className="category-title">{category.Named}</span>
        </div>

        <div className="category-items">
          {category.subcategories && category.subcategories.length > 0 ? (
            category.subcategories.map(sub => (
              <label
                key={`sub-${sub.Id}`}
                className={`service-row ${selected.includes(sub.Id) ? "selected" : ""}`}
              >
                <div className="service-left">
                  <input
                    className="hidden-checkbox"
                    id={`chk-${sub.Id}`}
                    type="checkbox"
                    checked={selected.includes(sub.Id)}
                    onChange={() => handleCheckboxChange(sub.Id)}
                  />
                  <span className="custom-checkbox" aria-hidden="true">
                    <svg viewBox="0 0 24 24" className="checkmark" aria-hidden="true">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </span>
                  <span className="service-name">{sub.Named}</span>
                </div>

                <div className="service-right">
                  {selected.includes(sub.Id) && (
                    <input
                      type="number"
                      placeholder="Net Experience"
                      className="experience-input" style={{backgroundColor:"white", color:"black", fontWeight:"bold"}}
                      value={experienceMap[sub.Id] || ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        setExperienceMap(prev => ({ ...prev, [sub.Id]: value }));
                      }}
                      required
                      min="0"
                      inputMode="numeric"
                    />
                  )}
                </div>
              </label>
            ))
          ) : (
            <label
              key={`catonly-${category.Id}`}
              className={`service-row ${selected.includes(category.Id) ? "selected" : ""}`}
            >
              <div className="service-left">
                <input
                  className="hidden-checkbox"
                  id={`chk-cat-${category.Id}`}
                  type="checkbox"
                  checked={selected.includes(category.Id)}
                  onChange={() => handleCheckboxChange(category.Id)}
                />
                <span className="custom-checkbox" aria-hidden="true">
                  <svg viewBox="0 0 24 24" className="checkmark" aria-hidden="true">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                </span>
                <span className="service-name">{category.Named}</span>
              </div>

              <div className="service-right">
                {selected.includes(category.Id) && (
                  <input
                    type="number"
                    placeholder="Experience (yrs)"
                    className="experience-input"  style={{backgroundColor:"white", color:"black", fontWeight:"bold"}}
                    value={experienceMap[category.Id] || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      setExperienceMap(prev => ({ ...prev, [category.Id]: value }));
                    }}
                    required
                    min="0"
                    inputMode="numeric"
                  />
                )}
              </div>
            </label>
          )}
        </div>
      </div>
    ))}
  </div>

  {/* ✅ keeping your original button */}
  <div style={{ marginTop: 12 }}>
    <button type="submit" disabled={isSubmitting} style={{marginTop:"30px", minWidth:"200px", height:"40px", fontWeight:"bold", border:"solid black 2px"}}>
      {isSubmitting ? "Please Wait..." : "Submit For Verification"}
    </button>
  </div>

  <style>{`
    /* Container grid */
    .services-grid {
      display: grid;
      grid-template-columns: 1fr;
      gap: 14px;
      max-width: 920px;
      margin: 0 auto;
    }
    @media (min-width: 900px) {
      .services-grid {
        grid-template-columns: 1fr 1fr;
      }
    }

    /* Category cards with soft white background */
    .category-card {
      border: 1px solid #e6e9ee;
      border-radius: 10px;
      background: linear-gradient(180deg, #ffffff, #f9f9f9);
      padding: 12px;
      box-shadow: 0 3px 12px rgba(0, 0, 0, 0.04);
      transition: transform 0.12s ease, box-shadow 0.12s ease;
    }
    .category-card:hover {
      transform: translateY(-3px);
      box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
    }

    .category-header {
      border-bottom: 1px dashed silver;
      padding-bottom: 8px;
      margin-bottom: 10px;
    }
    .category-title {
      font-weight: 700;
      font-size: 15px;
      color: #14a077;
    }

    .category-items {
      display: flex;
      flex-direction: column;
      gap: 0px;
    }

    /* Service row */
    .service-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      padding: 10px;
      border-radius: 8px;
      transition: background 0.12s, border-color 0.12s;
      cursor: pointer;
      border: 1px solid transparent;
    }
    .service-row:hover {
      background: #fdfdfd;
      border-color: #f0f0f0;
    }
    .service-row.selected {
      background: #f6fbf9;
      border-color: #cceede;
    }

    .service-left {
      display: flex;
      align-items: center;
      gap: 12px;
      flex: 1;
    }

    .service-name {
      font-size: 14px;
      color: #222;
      font-weight: 500;
    }

    /* Checkbox */
    .hidden-checkbox {
      position: absolute;
      left: -9999px;
      opacity: 0;
    }

    .custom-checkbox {
      width: 22px;
      height: 22px;
      border-radius: 6px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      border: 1.5px solid #cfd8e3;
      transition: background 0.12s, border-color 0.12s;
    }
    .service-row.selected .custom-checkbox {
      background: #14a077;
      border-color: #14a077;
    }

    .custom-checkbox .checkmark {
      width: 14px;
      height: 14px;
      stroke: #fff;
      stroke-width: 2;
      fill: none;
      stroke-linecap: round;
      stroke-linejoin: round;
      opacity: 0;
      transition: opacity 0.12s;
    }
    .service-row.selected .custom-checkbox .checkmark {
      opacity: 1;
    }

    /* Experience input */
    .service-right {
      width: 150px;
      display: flex;
      justify-content: flex-end;
    }
    .experience-input {
      width: 140px;
      padding: 8px 10px;
      border-radius: 8px;
      border: 1px solid #d7dee8;
      outline: none;
      font-size: 14px;
      text-align: center;
      background: #ffffff;
      transition: box-shadow 0.12s, border-color 0.12s;
    }
    .experience-input:focus {
      border-color: #14a077;
      box-shadow: 0 4px 10px rgba(20, 160, 119, 0.1);
    }

    /* No services message */
    .no-services {
      padding: 18px;
      border-radius: 8px;
      background: #fff9f7;
      border: 1px solid #ffecd1;
      color: #bf3b0a;
      font-weight: 600;
    }
  `}</style>
</form>
 <style>
{`
  .Toastify__close-button {
    display: none;
  }

  .Toastify__toast {
    position: relative;
    padding-right: 30px;
  }
`}
</style>
           <ToastContainer position="bottom-center"
  autoClose={5000}
  hideProgressBar={false}
  newestOnTop={false}
  closeOnClick
  rtl={false}
  pauseOnFocusLoss
  draggable
  pauseOnHover />
   <div className="group-ant-choice" style={{marginTop:"15px", textAlign:"center"}}>
                                                                             
                                                                              <Link to="/completeprofile" className="forgot" style={{margin:"auto", color:"#14a077"}}>
                                                                                Return To Verification Desk
                                                                              </Link>
                                                                            </div>
                     
                    </div>
                  </div>
                </div>
              </section>
      
        <div
                  className="floating-buttons"
                  style={{
                    position: "fixed",
                    bottom: "20px",
                    left: "20px",
                    zIndex: "1000",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  {/* Call Button */}
                  <a
                    href={`tel:+918960708425`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "60px",
                      height: "60px",
                      backgroundColor: "#007BFF",
                      borderRadius: "50%",
                      boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                      color: "white",
                      fontSize: "28px",
                    }}
                  >
                    <FaPhoneAlt />
                  </a>
                
                  {/* WhatsApp Button */}
                  <a
                    href={`https://wa.me/918960708425`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "60px",
                      height: "60px",
                      backgroundColor: "#25D366",
                      borderRadius: "50%",
                      boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                      color: "white",
                      fontSize: "28px",
                    }}
                  >
                    <FaWhatsapp />
                  </a>
                </div>
     
      <Gotop />
    </>
  );
}

export default DashboardAstroServices;
